/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { ILeagueModel, IMediaModel, RouteHelper } from "@bms/common";
import React from "react";
import { Link } from "react-router-dom";

export interface IAggregatedTeam {
  TeamId: NonNullable<ILeagueModel["Table"]>[number]["TeamId"];
  TeamName?: string | null;
  TeamMediaId?: number | null;
  TeamMediaTypeCode?: string | null;
  MatchesPlayed: number;
  Wins: number;
  Draws: number;
  Losses: number;
  GoalsScored: number;
  GoalsConceded: number;
  Points: number;
  Position: number;
}

interface ILeagueTeamRowProps {
  team: IAggregatedTeam;
  highlightTeamNames?: string[];
  hasMatchStats: boolean;
  hasGoals: boolean;
}

export const LeagueTeamRow = ({
  team,
  highlightTeamNames,
  hasMatchStats,
  hasGoals,
}: ILeagueTeamRowProps) => {
  const isHighlighted = highlightTeamNames?.includes(team.TeamName ?? "");
  const teamLink =
    team.TeamMediaId && team.TeamMediaTypeCode
      ? RouteHelper.getDetailsPath({
          MediaTypeCode: team.TeamMediaTypeCode,
          Id: team.TeamMediaId,
        } as IMediaModel)
      : undefined;

  return (
    <tr className={isHighlighted ? "LeagueTableTab__row--highlighted" : ""}>
      <td className="LeagueTableTab__col--pos">{team.Position}</td>
      <td className="LeagueTableTab__col--team">
        {teamLink ? (
          <Link to={teamLink} className="LeagueTableTab__link">
            {team.TeamName ?? "—"}
          </Link>
        ) : (
          team.TeamName ?? "—"
        )}
      </td>
      {hasMatchStats && (
        <>
          <td className="LeagueTableTab__col--stat">
            {team.MatchesPlayed ?? "—"}
          </td>
          <td className="LeagueTableTab__col--stat">{team.Wins ?? "—"}</td>
          <td className="LeagueTableTab__col--stat">{team.Draws ?? "—"}</td>
          <td className="LeagueTableTab__col--stat">{team.Losses ?? "—"}</td>
        </>
      )}
      {hasGoals && (
        <td className="LeagueTableTab__col--goals">
          {team.GoalsScored ?? "—"}:{team.GoalsConceded ?? "—"}
        </td>
      )}
      <td className="LeagueTableTab__col--pts">{team.Points ?? "—"}</td>
    </tr>
  );
};
